<template>
  <v-container fluid class="down-top-padding">
    <v-row>
      <v-col cols="12" lg="12">
        <v-card>
          <v-toolbar flat>
            <v-col cols="12" class="px-0">
              <div class="d-flex align-center">
                <div class="text-left">
                  <v-toolbar-title class="page-title">
                    For Installation
                  </v-toolbar-title>
                </div>
                <div class="ml-auto">
                  <!-- <v-btn
                    color="primary"
                    :disabled="isExporting"
                    :loading="isExporting"
                    @click="exportData()"
                  >
                    <v-icon class="mr-2">mdi-download</v-icon> Export
                  </v-btn> -->
                  <v-btn color="primary" class="ml-auto">
                    <download-csv :data="exportData" :name="`${fileName}.csv`">
                      <v-icon dense>mdi-download</v-icon>
                      Export
                    </download-csv>
                  </v-btn>
                </div>
              </div>
            </v-col>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-divider></v-divider>

          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search Reference Number, Account Number, Jo No, Name"
              single-line
              hide-details
              @click:append="searchRecord"
              @keydown.enter.prevent="searchRecord"
              clearable
              @click:clear="getList()"
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :page="table.page"
            :pageCount="table.numberOfPages"
            :options.sync="options"
            :server-items-length="table.total"
            :headers="table.headers"
            :items="table.data"
            :items-per-page="10"
            :loading="table.loading"
            item-key="_id"
            loading-text="Loading... Please wait"
            class="elevation-1"
            :footer-props="{
              'items-per-page-options': [10, 20, 50, 100],
            }"
          >
            <!-- <template
        v-for="header in headers.filter((header) =>
          header.hasOwnProperty('formatter')
        )"
        v-slot:[`item.${header.value}`]="{ value }"
      >
        {{ header.formatter(value) }}
      </template> -->

            <template
              v-for="header in table.headers.filter((header) =>
                header.hasOwnProperty('formatter')
              )"
              v-slot:[`item.${header.value}`]="{ value }"
            >
              {{ header.formatter(value) }}
            </template>

            <template v-slot:[`item.name`]="{ item }">
              {{
                `${item.firstName} ${item.middleName ? item.middleName : ""} ${
                  item.lastName
                }`
              }}
            </template>

            <template v-slot:[`item.isPaid`]="{ item }">
              {{ item.isPaid ? "Yes" : "No" }}
            </template>

            <template v-slot:[`item.amountPaid`]="{ item }">
              {{ item.amountPaid ? item.amountPaid.toLocaleString() : 0 }}
            </template>
            <template v-slot:[`item.approvedJO`]="{ item }">
              {{ item.approvedJO ? "Manual" : "Auto" }}
            </template>

            <template v-slot:[`item.account.jo_no`]="{ item }">
              {{ item.account.jo_no ? item.account.jo_no : "-" }}
            </template>
            <template v-slot:[`item.oltConfigured`]="{ item }">
              {{ item.oltConfigured ? "Yes" : "No" }}
            </template>

            <!-- <template v-slot:[`item.actions`]="{ item }">
        <v-btn x-small color="pink" dark @click="editDrawDetail(item)">
          Edit</v-btn
        >
      </template> -->
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      exportData: [],
      fileName: "",

      isExporting: false,
      search: "",
      paths: {
        viewInfo: "/draw/view",
      },

      table: {
        page: 0,
        total: 0,
        numberOfPages: 0,

        // sortBy: "dtCreated",
        // sortDesc: true,
        loading: false,
        headers: [
          {
            text: "Date",
            align: "start",
            sortable: true,
            value: "createdDate",
            formatter: (x) => (x ? moment(x).format("MMM DD, YYYY") : null),
          },
          {
            text: "JO Number",
            align: "start",
            sortable: false,
            value: "account.jo_no",
          },
          {
            text: "Distributor Name",
            align: "start",
            value: "distributorName",
            sortable: false,
          },
          {
            text: "NAP Code",
            align: "start",
            sortable: false,
            value: "napCode",
          },
          {
            text: "Referrence Numbe",
            align: "start",
            sortable: false,
            value: "referenceNumber",
          },
          {
            text: "City",
            align: "start",
            value: "city",
          },
          {
            text: "Area",
            align: "start",
            value: "area",
          },
          {
            text: "Subscriber Name",
            align: "start",
            value: "name",
          },
          // {
          //   text: "Paid",
          //   align: "center",
          //   value: "isPaid",
          // },

          {
            text: "Manual/Auto JO",
            align: "center",
            value: "approvedJO",
          },
          {
            text: "Acquirer",
            align: "start",
            value: "acquirer",
            sortable: false,
          },
          {
            text: "Territory Head",
            align: "start",
            value: "territoryHead",
            sortable: false,
          },
          {
            text: "Amount Paid",
            align: "start",
            value: "amountPaid",
            sortable: false,
          },

          {
            text: "OLT Configured",
            align: "start",
            value: "oltConfigured",
          },

          {
            text: "Payment Date",
            align: "start",
            value: "paymentDate",
            sortable: true,
            formatter: (x) => (x ? moment(x).format("MMM DD, YYYY") : null),
          },
        ],
        data: [],
      },

      options: {
        page: 1,
      },
    };
  },
  // props: ["tableAPIUrl", "reload", "headers"],

  methods: {
    async getList(searchVal = "") {
      this.table.loading = true;
      const { page, itemsPerPage } = this.options;
      let pageNumber = "";
      if (itemsPerPage === -1) {
        pageNumber = "";
      } else {
        pageNumber = page ? page : 1;
      }

      const perPage = itemsPerPage < 0 ? "" : itemsPerPage;

      await this.$api
        .get(`/acquisition/report?report=paid&page=${pageNumber}&limit=${perPage}&searchVal=${searchVal}`)
        .then((response) => {
          const newArr = response.data.data;
          this.table.data = newArr;
          const total = response.data.total;
          this.table.total =total;
          this.table.numberOfPages = Math.ceil(total / itemsPerPage);
          console.log(newArr);
          let exportData = newArr.map((item) => {
            return {
              // "Payment Date": moment(item.paymentDate).format("MM/DD/YYYY"),
              "Payment Date": item.paymentDate,
              "JO Number": item.account.jo_no ? "'" + item.account.jo_no : "",
              "Distributor Name": item.distributorName,
              "Account Number": item.accountNumber,
              "Referrence Number": item.referenceNumber,
              // Name: `${item.name}${
              //   item.middleName ? ", " + item.middleName : ""
              // }`,
              Name: `${item.firstName} ${
                item.middleName ? item.middleName : ""
              } ${item.lastName}`,
              Address: item.address,
              Region: item.region,
              Province: item.province,
              Municipality: item.city,
              "Dispatch to": "",
              Category: "",
              "Contact Details": item.mobileNumber,
              Remarks: "",
              Plan: "",
              "NAP Code": item.napCode,
              Port: item.port,
              Area: item.area,
              "Manual/Auto JO": item.approvedJO ? "Manual" : "Auto",
              Acquirer: item.acquirer,
              "Acquirer Contact Number": item.acquirerContact,
              "Territory Head": item.territoryHead,
              "OLT Configured": item.oltConfigured ? "Yes" : "No",
              "OLT Name": item.oltName,
            };
          });

          exportData.sort(function (a, b) {
            return new Date(b["Payment Date"]) - new Date(a["Payment Date"]);
          });

          this.fileName = `for_installation_as_of_${moment(
            moment().toDate()
          ).format("MMM_DD_YYYY")}`;
          this.exportData = exportData;

          this.table.loading = false;
        })
        .catch((e) => {
          this.table.loading = false;
          console.log(e);
        });
    },

    searchRecord() {
      this.options.page = 1;
      if (!this.search) {
        return;
      }

      this.getList(this.search);
    },

    // async exportData() {
    //   this.isExporting = true;
    //   await this.$api
    //     .post("/export", {
    //       method: "exportByStatus",
    //       status: "PAID",
    //     })
    //     .then((response) => {
    //       // console.log(response);
    //       const res = response.data;
    //       this.isExporting = false;

    //       if (!res.status) {
    //         alert(
    //           "Something went wrong. Please reload the page and export again."
    //         );
    //         return;
    //       }

    //       var fileLink = document.createElement("a");
    //       fileLink.href = res.data.link;
    //       document.body.appendChild(fileLink);
    //       fileLink.click();
    //     })
    //     .catch((e) => {
    //       // this.table.loading = false;
    //       this.isExporting = false;
    //       console.log(e);
    //     });
    // },
  },
  mounted() {
    this.getList();
    // console.log(this.$props.headers);
  },

  watch: {
    // reload(val) {
    //   this.getDrawList(val);
    // },

    options: {
      handler() {
        this.getList(this.search);
      },
      deep: true,
    },
  },

  computed: {
    // getPartner() {
    //   return this.$store.getters.getPartner;
    // },
  },
};
</script>
